export default "__VITE_ASSET__KpQ4cXlC__"